import { reactive, toRefs, ref, watch, computed } from "vue";
import DeviceStateHistoryLocal from "@/views/deviceManage/deviceRunData/components/DeviceStateHistory.vue";
import { useRoute } from "vue-router";
export default {
  name: "DeviceStateMqtt",
  props: ["deviceId", "productId", "deviceState", "actType"],
  components: {
    "actuator-state-history": DeviceStateHistoryLocal
  },
  setup(props) {
    const zxqShowHistory = ref();
    const route = useRoute();
    const valveSwitch = ref(props.deviceState.valuePos === 1 ? 1 : 0);
    const state = reactive({
      runData: {
        batLevel: '-',
        batTime: '-',
        bottleNumber: '-',
        bottlePressure: '-',
        humidity: '-',
        protectPressure: '-',
        supplyPressure: '-',
        temp: '-',
        valuePos: '-',
        valuePosDesc: '-',
        valueOpenPos: '-',
        batCouValue: '-',
        cylinderSnType: '-',
        switchTimeout: '-',
        signalStrength: '-'
      }
    });
    const methods = reactive({
      showDetailDialog(indi, unit, name) {
        let row = {
          id: "",
          indicator: indi,
          opstartTime: "",
          opEndTime: "",
          unit: unit,
          legend: name
        };
        zxqShowHistory.value.show(row, "历史数据");
      },
      getCylinderSnTypeLabel(value) {
        if (value == 0) {
          return '压力传感器';
        } else if (value == 1) {
          return '宝鸡麦克';
        }
        return value || '-';
      }
    });

    // MQTT: valuePos == 2 为异常
    const isValveAbnormal = computed(() => state.runData.valuePos == 2);
    watch(() => props.deviceState, val => {
      state.runData = {
        ...props.deviceState
      };
      valveSwitch.value = props.deviceState.valuePos === 1 ? 1 : 0;
      let valueOpenPos = "";
      if (props.actType == 1) {
        valueOpenPos = state.runData.valuePos == 1 ? 100 : 0;
      } else {
        valueOpenPos = state.runData.valueOpenPos == null ? '-' : state.runData.valueOpenPos;
      }
      state.runData.valueOpenPos = valueOpenPos;
    }, {
      deep: true
    });
    return {
      ...toRefs(state),
      ...toRefs(methods),
      zxqShowHistory,
      valveSwitch,
      isValveAbnormal
    };
  }
};